import apiCompatibilityGroups from './compatibilities';

export const testApiVersion = ({config, versions}) => {
	testVersions({
		name: config.name,
		compatibleVersions: config.versions.api,
		versions,
	});
}

export const testApiVersionGroup = ({config, versions}) => {
	const compatibleVersions = apiCompatibilityGroups[config.versionGroups.api];
	testVersions({
		name: config.name,
		compatibleVersions,
		versions,
	});
}

const testVersions = ({name, compatibleVersions, versions}) => {
	if(!compatibleVersions.includes(versions.api)){
		console.error(`Using a component ${name} with an incompatible api version ${versions.api}.\n
			Compatible versions: ${compatibleVersions.join(', ')}.`);
	}
}